import { EntityClaim } from "../../entity/EntityClaim";

export class DtoClaimsPostRes extends EntityClaim {}
